export const DRAFT_KEY = "mbs_kusur_sorgu_draft_v2";

export const TABS = [
    { id: "analiz", label: "Analiz Merkezi", icon: "BadgePercent" },
    { id: "kayitlar", label: "Kayıtlar", icon: "Archive" },
    { id: "rehber", label: "KTK Rehberi", icon: "BookOpen" },
];

export const SORGU_MODLARI = [
    { id: "sistem", label: "Sistem Dosyası", hint: "Evrak + otomatik doldurma" },
    { id: "anlik", label: "Anlık Sorgu", hint: "Dosyasız hızlı analiz" },
];

export const UPLOAD_ZONES = [
    { key: "tutanak", label: "KTT Tutanak", hint: "PDF / foto — kroki, işaretler" },
    { key: "eksper", label: "Eksper Raporu", hint: "Hasar ve kusur değerlendirmesi" },
    { key: "foto", label: "Kaza Fotoğrafları", hint: "Olay yeri, hasar, işaretler" },
    { key: "video", label: "Video / Dashcam", hint: "MP4, MOV" },
    { key: "diger", label: "Beyan / SBM", hint: "Tanık, kusur yazısı" },
];

export const WORKFLOW_STEPS = [
    { id: "delil", label: "Delil", desc: "Evrak seç / yükle" },
    { id: "okuma", label: "Okuma", desc: "OCR + form doldur" },
    { id: "analiz", label: "Analiz", desc: "AI kusur motoru" },
    { id: "rapor", label: "Rapor", desc: "Kayıt + PDF" },
];

export const SONUC_TABS = [
    { id: "ozet", label: "Özet" },
    { id: "tutanak", label: "Tutanak" },
    { id: "deliller", label: "Deliller" },
    { id: "itiraz", label: "İtiraz" },
    { id: "strateji", label: "Strateji" },
];

export const EMPTY_FORM = {
    sigorta_dosyasi_id: "",
    baslik: "",
    kaza_tarihi: "",
    kaza_yeri: "",
    plaka_a: "",
    plaka_b: "",
    taraf_a_adi: "",
    taraf_b_adi: "",
    olay_ozeti: "",
    beyan_metni: "",
    mevcut_kusur_orani: "",
};

export const INPUT_CLS =
    "h-8 bg-[#0B1220] border-white/10 text-white text-sm placeholder:text-slate-600 focus-visible:ring-[#a31d21]/40";
export const SELECT_CLS = `${INPUT_CLS} w-full rounded-md px-2.5`;
